import axios from 'axios';

class Follow {
  constructor() {
    if (this instanceof Follow) {
      throw Error('Follow class cannot be instantiated.');
    }
  }
  
  static onFetchFollowInfo = async ({ user_id, slug }, sucessCallback, errorCallback) => {
    const params = {
      locale: window.$currentUserLanguage,
      auth_token: window.$currentUserAuthToken,
      user_id,
      slug
    }
    await axios.get(`/api/v4/follows.json`, { params })
    .then(res => sucessCallback(res.data))
    .catch((error) => {
      try {
        errorCallback(error.response.data)
      } catch (e) {

      } finally {}
    });
  }

  static onFollow = async (user_id, sucessCallback, errorCallback) => {
    const params = {
      locale: window.$currentUserLanguage,
      auth_token: window.$currentUserAuthToken,
      user_id
    }
    await axios.post(`/api/v4/follows.json`, params)
    .then(res => sucessCallback(res.data))
    .catch((error) => {
      try {
        errorCallback(error.response.data)
      } catch (e) {

      } finally {}
    });
  }

  static onUnfollow = async (user_id, sucessCallback, errorCallback) => {
    const params = {
      locale: window.$currentUserLanguage,
      auth_token: window.$currentUserAuthToken
    }
    await axios.delete(`/api/v4/follows/${user_id}.json`, { params })
    .then(res => sucessCallback(res.data))
    .catch((error) => {
      try {
        errorCallback(error.response.data)
      } catch (e) {

      } finally {}
    });
  }

  static onFetchFollowers = async ({ user_id, page, per, term }, sucessCallback, errorCallback) => {
    const params = {
      locale: window.$currentUserLanguage,
      auth_token: window.$currentUserAuthToken,
      user_id,
      page,
      per,
      term
    }
    await axios.get(`/api/v4/follows/followers.json`, { params })
    .then(res => sucessCallback(res.data))
    .catch((error) => {
      try {
        errorCallback(error.response.data)
      } catch (e) {

      } finally {}
    });
  }

  static onFetchFollowees = async ({ user_id, page, per, term }, sucessCallback, errorCallback) => {
    const params = {
      locale: window.$currentUserLanguage,
      auth_token: window.$currentUserAuthToken,
      user_id,
      page,
      per,
      term
    }
    await axios.get(`/api/v4/follows/followees.json`, { params })
    .then(res => sucessCallback(res.data))
    .catch((error) => {
      try {
        errorCallback(error.response.data)
      } catch (e) {

      } finally {}
    });
  }

}

export default Follow;
